import { Box, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React from 'react';

const useStyle = makeStyles((theme) => ({
  save: {
    display: 'flex',
    justifyContent: 'end',
    width: '100%',
    margin: 16,
  },
  cancel: {
    marginRight: 16,
  },
}));

export const SaveImage = ({
  setOpen,
  croppedImage,
  setLoading,
  setImage,
  image,
  id,
}) => {
  const classes = useStyle();

  //**dataURL to blob**
  const dataURLtoBlob = (dataurl) => {
    let arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  }

  const saveImage = () => {
    if (typeof croppedImage !== 'undefined') {
      let dataURI = croppedImage
        .getCroppedCanvas()
        .toDataURL('image/jpeg', 0.1);

      setLoading(true);

      let url = URL.createObjectURL(dataURLtoBlob(dataURI));

      !id && localStorage.setItem('meetingImageUrl', dataURI);
      !id && localStorage.setItem('meetingImageBlob', url);

      setImage({
        ...image,
        blob: dataURLtoBlob(dataURI),
        value: url,
        error: false,
      });
      setOpen(false);
      setLoading(false);
    }
  };

  return (
    <Box className={classes.save}>
      <Button
        size='small'
        variant='outlined'
        onClick={() => {
          setOpen(false);
        }}
        className={classes.cancel}
      >
        Cancel
      </Button>
      <Button
        size='small'
        variant='contained'
        color='primary'
        onClick={saveImage}
      >
        crop
      </Button>
    </Box>
  );
};
